import usePageViewTracker from '@cohort/wallet/hooks/pageViewTracker';
import type {TrackingConfig} from '@cohort/wallet/lib/Tracking';
import {Fragment} from 'react';

type PageViewTrackerProps = {
  namespace: TrackingConfig['namespace'];
  metadata?: Record<string, unknown>;
  children: React.ReactNode;
};

const PageViewTracker: React.FC<PageViewTrackerProps> = ({namespace, metadata, children}) => {
  usePageViewTracker(namespace, metadata);

  return <Fragment>{children}</Fragment>;
};

export default PageViewTracker;
